import React, { createContext, useContext, ReactNode } from 'react';
import type { Campaign } from '@shared/types/mylounge';
import type { LayoutConfig } from '../utils/deriveLayoutConfig';
import type { TopPicks4UGenderData } from '../hooks';

export interface GridLayoutContextValue {
    campaigns: Campaign[];
    isPlusEnabled: boolean;
    columnCount: number;
    layoutConfig: LayoutConfig;
    isNewDealsToday: boolean;
    isSemanticArticleCarousel: boolean;
    topPicks4UGenderData: TopPicks4UGenderData;
    isContinueShopping: boolean;
    /**
     * INTERNAL METHODS
     * Used only by DeclarativeGrid for offset calculation.
     * Do NOT use in other components.
     */
    _resetCampaignIndex: () => void;
    _getAndIncrementIndex: (count: number) => number;
}

const GridLayoutContext = createContext<GridLayoutContextValue | null>(null);

interface GridLayoutProviderProps {
    value: GridLayoutContextValue;
    children: ReactNode;
}

export const GridLayoutProvider: React.FC<GridLayoutProviderProps> = ({ value, children }) => {
    return <GridLayoutContext.Provider value={value}>{children}</GridLayoutContext.Provider>;
};

export const useGridLayoutContext = (): GridLayoutContextValue => {
    const context = useContext(GridLayoutContext);
    if (!context) {
        throw new Error('useGridLayoutContext must be used within a GridLayoutProvider');
    }
    return context;
};
